import { render, staticRenderFns } from "./DormantAfterTrialSettings.vue?vue&type=template&id=2626bed9&scoped=true&"
import script from "./DormantAfterTrialSettings.vue?vue&type=script&lang=js&"
export * from "./DormantAfterTrialSettings.vue?vue&type=script&lang=js&"
import style0 from "./DormantAfterTrialSettings.vue?vue&type=style&index=0&id=2626bed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626bed9",
  null
  
)

export default component.exports